import { Cart } from '@/http/Cart'

export const cart = {
    namespaced: true,
    state: {
        products: {},
        token: '',
    },
    getters: {
        get: state => {
            return state.products
        },
        getItems: state => {
            return state.products.lineItems
        },
        getQty: state => {
            return state.products.totalQty
        },
        getToken: state => {
            return state.token
        },

    },
    mutations: {
        set: (state, products) => {
            state.products = products;
        },
        setToken: (state, token) => {
            state.token = token;
        },
    },
    actions: {
        async fetch({ commit }){
            const { data } = await Cart.get();
            commit('set', data.cart);
        },
        // Commerce's update-cart response can return duplicated lineItems (Commerce 5.7.2 bug), so refetch via get-cart instead of trusting it
        async add({ dispatch }, id){
            await Cart.add(id);
            await dispatch('fetch');
        },
        async remove({ dispatch }, id){
            await Cart.remove(id);
            await dispatch('fetch');
        },
        async update({ dispatch }, pdata){
            await Cart.update(pdata.id, pdata.qty);
            await dispatch('fetch');
        },
        async addCouponCode({ dispatch }, couponCode){
            await Cart.addCouponCode(couponCode);
            await dispatch('fetch');
        },

    },
}
